import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { isPackageEligibleForQrPdf } from "util/scan-code-print";

const QRModal = ({ open, onClose, qrOrder, selectedDNs, setSelectedDNs }) => {
  const selectedDns = (qrOrder?.DeliveryNotes || []).filter((dn) =>
    selectedDNs.includes(dn.id)
  );
  const canPrintSelection = selectedDns.some((dn) =>
    (dn.Packages || []).some((p) => isPackageEligibleForQrPdf(p))
  );
  const printDisabled = selectedDNs.length === 0 || !canPrintSelection;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 420,
          bgcolor: "#1F1F1F",
          color: "white",
          borderRadius: "8px",
          boxShadow: 24,
          p: 3,
        }}
      >
        <h3 style={{ marginTop: 0 }}>QR Options</h3>
        <p style={{ marginBottom: "20px" }}>
          Order #: {qrOrder?.order_number || qrOrder?.id}
        </p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
            cursor: "pointer",
            gap: "10px",
          }}
          onClick={() => {
            const all = qrOrder?.DeliveryNotes?.map((dn) => dn.id) || [];
            setSelectedDNs(
              selectedDNs.length === all.length ? [] : all
            );
          }}
        >
          <input
            type="checkbox"
            checked={
              qrOrder?.DeliveryNotes &&
              selectedDNs.length === qrOrder.DeliveryNotes.length
            }
            readOnly
          />
          <span>Select All Delivery Notes</span>
        </div>

        <div
          style={{
            maxHeight: "220px",
            overflowY: "auto",
            marginBottom: "20px",
            paddingRight: "5px",
          }}
        >
          {qrOrder?.DeliveryNotes?.map((dn) => (
            <div
              key={dn.id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "8px 0",
                borderBottom: "1px solid #333",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="checkbox"
                  checked={selectedDNs.includes(dn.id)}
                  onChange={() => {
                    setSelectedDNs((prev) =>
                      prev.includes(dn.id)
                        ? prev.filter((id) => id !== dn.id)
                        : [...prev, dn.id]
                    );
                  }}
                />
                <span>{dn.delivery_note_number}</span>
              </div>
              <span style={{ opacity: 0.8 }}>
                {Array.isArray(dn.Packages) ? dn.Packages.length : 0} packages
              </span>
            </div>
          ))}
        </div>

        <button
          disabled={printDisabled}
          style={{
            padding: "12px",
            width: "100%",
            background:
              printDisabled ? "#777" : "#6F9CEB",
            border: "none",
            borderRadius: "4px",
            cursor: printDisabled ? "not-allowed" : "pointer",
            color: "black",
            fontWeight: "bold",
          }}
          onClick={async () => {
            if (printDisabled) return;

            try {
              const response = await fetch(
                `${import.meta.env.VITE_API}routes/scan-codes-flexible`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                  },
                  body: JSON.stringify({
                    orderId: qrOrder?.id,
                    deliveryNoteIds: selectedDNs,
                  }),
                }
              );

              if (!response.ok) {
                throw new Error("Failed to generate QR PDF");
              }

              const blob = await response.blob();
              const pdfURL = window.URL.createObjectURL(blob);
              window.open(pdfURL);
            } catch (err) {
              console.error("QR PRINT ERROR:", err);
            }
          }}
        >
          Print Selected QR Codes
        </button>
      </Box>
    </Modal>
  );
};
export default QRModal;
